<div class="card h-full flex flex-col">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-xl font-semibold">Actions Correctives</h2>
    <button
      *ind4HasRole="'SED_PLUS_REGULAR_USER'"
      pButton
      pRipple
      icon="pi pi-pencil"
      label="Modifier"
      class="p-button-sm p-button-outlined"
      (click)="openEditModal()"
    ></button>
  </div>
  <app-data-state [loading]="loading$ | async" [error]="error$ | async">
    <div class="p-fluid flex-1 flex flex-col">
      <div class="flex flex-col flex-1 justify-center gap-2">
        <ng-template #noData>
          <app-no-data></app-no-data>
        </ng-template>
        <div
          *ngIf="sortedCorrectiveActions?.length; else noData"
          class="action-list"
        >
          <div
            *ngFor="let action of sortedCorrectiveActions"
            class="action-item"
          >
            <div class="action-icon">
              <i-lucide
                name="wrench"
                class="text-blue-400 mt-icon"
                [size]="16"
              ></i-lucide>
            </div>
            <div class="text-sm text-gray-600 dark:text-gray-300">
              {{ action?.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-data-state>

  <!-- Edit Modal -->
  <app-edit-corrective-actions-modal
    [visible]="showEditModal"
    [items]="correctiveActions ?? []"
    [ruleUid]="ruleUid ?? ''"
    (visibleChange)="showEditModal = $event"
    (onSubmitForm)="onModalSubmit($event)"
    (onCancelForm)="onModalCancel()"
  ></app-edit-corrective-actions-modal>
</div>
